import Swal from "sweetalert2";

/**
 * Pokazuje toast notification z SweetAlert2
 * @param message Treść wiadomości
 * @param icon Typ alertu (`success`, `error`, `warning`, `info`)
 */
export function showToast(message: string, icon: "success" | "error" | "warning" | "info") {
    Swal.fire({
        toast: true,
        position: "bottom-end",
        icon,
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
}